import { createContext, Dispatch, SetStateAction, useContext } from 'react'
import dayjs from 'dayjs'
export interface ISalaryWeekContext {
  weekFilter: dayjs.Dayjs | null
  setWeekFilter: Dispatch<SetStateAction<dayjs.Dayjs | null>>
}

export const SalaryWeekContext = createContext<ISalaryWeekContext>({} as ISalaryWeekContext)
export const useSalaryWeekContext = (): ISalaryWeekContext => useContext(SalaryWeekContext)
